module.exports = __webpack_public_path__ + "img/pd-img6.d5209de1.png";